<!-- Refer a friend popup section -->
<div>
    <div class="modal-dialog modal-dialog-centered refermodal">
        <div class="modal-content">
            <button type="button" class="popup-close" data-bs-dismiss="modal" (click)="dialog.dismissAll();">
                <img _ngcontent-rux-c102="" src="/assets/images/close-button.svg" alt="close icon">
            </button>
            <div class="referwrapper">
                <div class="refer-modal-content" style="padding: 15px;">
                    <div class="img-section d-none d-md-block">
                        <img src="/assets/images/referafriend.webp" alt="friends">
                    </div>
                    <div class="text-section">
                        <h1 class="heading1">Refer-A-Friend</h1>
                        <p>This will be added by Jan 1, 2024. A person will be able to Refer-A-Friend, if they sign up the Friend will get $25 off their Subscription. This person making the referral will recive a $25.00 electronic Visa card after the referred person signs up and is active for 30 days. Max referral 10 Subscribers. </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>